import React, { Component } from 'react';
import { connect } from 'react-redux';
import Pagination from '@material-ui/lab/Pagination';
import PaginationItem from '@material-ui/lab/PaginationItem';
import './ExternalDataHistoryListComponent.css';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Button,
  Box,
  Grid,
} from '@material-ui/core';
import { setSystemLodingFLg } from '../../actions/CommonAction';
import {
  setNowPage,
  setExternalDataHistoryList,
  createDownloadFile,
  searchPaging,
  executeFileDownload,
} from '../../actions/ExternalDataHistoryAction';
import {
  DISP_COUNT_LIMIT,
  EXTERNALDATA_RESULTPAGING,
  EXTERNALDATA_STATUS,
} from '../../../common/const';
import MyIcon from '../common/MyIcon';

class ExternalDataHistoryListComponent extends Component {
  /**
   * ページ選択
   * @param {string} page
   */
  changePage = async (page) => {
    const {
      setSystemLodingFlgAct,
      setNowPageAct,
      setExternalDataHistoryListAct,
      searchPagingAct,
    } = this.props;
    setNowPageAct(page);
    // 検索API呼出し
    setSystemLodingFlgAct(true);
    const response = await searchPagingAct(page);
    setSystemLodingFlgAct(false);
    setExternalDataHistoryListAct(response);
  }

  /**
   * ダウンロードボタン押下
   */
  onClickCreateDownloadFile = async () => {
    const {
      createDownloadFileAct,
      setSystemLodingFlgAct,
      executeFileDownloadAct,
    } = this.props;
    setSystemLodingFlgAct(true);
    const count = await createDownloadFileAct();
    if (count <= DISP_COUNT_LIMIT.EXTERNALDATA_HISTORY
      && count !== 0) {
      await executeFileDownloadAct();
    }
    setSystemLodingFlgAct(false);
  }

  render() {
    const {
      externalDataHistoryList,
      nowPage,
      limitMessage,
    } = this.props;
    // ページングの表示処理 ここから
    let pagingArea = null;
    let totalCount = null;

    // 全体件数が最大取得件数以上の場合、全体件数を最大取得件数に設定
    if (externalDataHistoryList
      && externalDataHistoryList.all_count) {
      totalCount = externalDataHistoryList.all_count < DISP_COUNT_LIMIT.EXTERNALDATA_HISTORY
        ? externalDataHistoryList.all_count : DISP_COUNT_LIMIT.EXTERNALDATA_HISTORY;
    }

    // 全体件数が最大表示件数以下の場合、ページング表示処理を実施
    if (externalDataHistoryList
      && totalCount) {
      const maxPageCount = totalCount === 0
        ? 1
        : Math.ceil(totalCount / EXTERNALDATA_RESULTPAGING.PAGE_RECORD_COUNT);

      pagingArea = (
        <Pagination
          variant="outlined"
          count={maxPageCount}
          onChange={(e, page) => this.changePage(page)}
          page={nowPage}
          className="pagingArea"
          renderItem={(item) => (
            <PaginationItem
              {...item}
              disabled={
                item.page === nowPage
                || (item.type === 'next' && nowPage === maxPageCount)
                || (item.type === 'previous' && nowPage === 1)
              }
              className={`${item.page === nowPage ? 'customPaginationItem' : ''}`}
            />
          )}
        />
      );
    }
    // ページングの表示処理 ここまで
    // 表示件数作成
    const dispCountStart = (nowPage - 1) * EXTERNALDATA_RESULTPAGING.PAGE_RECORD_COUNT + 1;
    const dispCountEnd = (externalDataHistoryList
      && externalDataHistoryList.result_count
      && totalCount
      && totalCount <= DISP_COUNT_LIMIT.EXTERNALDATA_HISTORY)
      ? (nowPage - 1) * EXTERNALDATA_RESULTPAGING.PAGE_RECORD_COUNT
        + Number(externalDataHistoryList.result_count)
      : null;
    const dispResultCount = dispCountEnd ? `${dispCountStart}-${dispCountEnd}` : 0;

    // 全体件数
    const allCount = (externalDataHistoryList && totalCount)
      ? Number(totalCount).toLocaleString()
      : 0;

    return (
      <div className="externalDataHistoryList">
        <div className="content">
          <div className="resultCount">
            <span className="searchResult">{dispResultCount}</span>
            {` / ${allCount}件`}
          </div>
          <Grid className="summary-page">
            {pagingArea}
            {externalDataHistoryList && externalDataHistoryList.result_count > 0
            && (
            <Button
              variant="contained"
              color="secondary"
              onClick={this.onClickCreateDownloadFile}
              startIcon={<MyIcon className="faceIcon" type="download" />}
              className="download"
            >
              ダウンロード
            </Button>
            )}
            {limitMessage
          && (
          <span className="limitMessage">{limitMessage}</span>
          )}

          </Grid>
          <Box className="searchResultarea">
            <div className="searchResultareaTableHead">
              <Table className="tableLayout">
                <TableHead>
                  <TableRow>
                    <TableCell className="resultTableHeader processNo">処理番号</TableCell>
                    <TableCell className="resultTableHeader cooperationDate">連携日時</TableCell>
                    <TableCell className="resultTableHeader status">ステータス</TableCell>
                    <TableCell className="resultTableHeader tsrCd">TSRコード</TableCell>
                    <TableCell className="resultTableHeader jigyosyo">事業所名</TableCell>
                    <TableCell className="resultTableHeader tsrCompanyCd">TSR企業コード</TableCell>
                    <TableCell className="resultTableHeader syogo">商号</TableCell>
                    <TableCell className="resultTableHeader tradeKey">取引情報キー</TableCell>
                  </TableRow>
                </TableHead>
              </Table>
            </div>
            <div className="productsconditionTableBody">
              <Table className="tableLayout">
                <TableBody className="searchResultareaTableBody">
                  {externalDataHistoryList
                    && externalDataHistoryList.common_history_list
                    && externalDataHistoryList.common_history_list.map((resultset, i) => (
                      <TableRow key={i}>
                        <TableCell className="resultTableCell processNo padding">
                          {resultset.process_no}
                        </TableCell>
                        <TableCell className="resultTableCell cooperationDate">
                          {resultset.cooperation_date}
                        </TableCell>
                        <TableCell className="resultTableCell status">
                          {EXTERNALDATA_STATUS.map((listStatus) => (listStatus.key === resultset.status ? (listStatus.value) : ''))}
                        </TableCell>
                        <TableCell className="resultTableCell tsrCd">
                          {resultset.tsr_cd}
                        </TableCell>
                        <TableCell className="resultTableCell jigyosyo">
                          {resultset.jigyosyo}
                        </TableCell>
                        <TableCell className="resultTableCell tsrCompanyCd">
                          {resultset.tsr_company_cd}
                        </TableCell>
                        <TableCell className="resultTableCell syogo">
                          {resultset.syogo}
                        </TableCell>
                        <TableCell className="resultTableCell tradeKey">
                          {resultset.torihiki_info_key}
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </div>
          </Box>
        </div>
      </div>
    );
  }
}

export default connect(
  (state) => ({
    nowPage: state.externaldata.nowPage,
    externalDataHistoryList: state.externaldata.externalDataHistoryList,
    limitMessage: state.externaldata.limitMessage,
  }),
  (dispatch) => ({
    setSystemLodingFlgAct: (bool) => dispatch(setSystemLodingFLg(bool)),
    searchPagingAct: (obj) => dispatch(searchPaging(obj)),
    setNowPageAct: (str) => dispatch(setNowPage(str)),
    setExternalDataHistoryListAct: (obj) => dispatch(setExternalDataHistoryList(obj)),
    createDownloadFileAct: () => dispatch(createDownloadFile()),
    executeFileDownloadAct: () => dispatch(executeFileDownload()),
  }),
)(ExternalDataHistoryListComponent);
